import { IBookingParams } from '../../core/interfaces/booking-params';

export class AddBookingParams {
  static readonly type = '[bookingParams] Add';

  constructor(public params: IBookingParams) {}
}
